import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { getBaseLoginUrl } from "../../utils/baseUrl";

const Redirection = ({ logout }) => {

	useEffect(() => {
		// Logout et destruction de la session lors de l'arrivée sur ce composant
		// Et redirection vers la page login
		logout();
		window.location.href = getBaseLoginUrl();
		window.localStorage.clear();
	}, []);

	return (
		<div>
		</div>
	);
};

Redirection.propTypes = {
	logout: PropTypes.func
};

export default Redirection;